export default __webpack_public_path__ + "static/media/Payment-Visa.28dc1fe7.png";